import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { NewButton, SaveButton } from "../../../../components/Buttons";

export const Product = () => {
    document.title = "Məhsul";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters" },
        { name: "Məhsul", value: "/products/parameters/product", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Məhsul</h2>
                    <p>
                        Məhsul və xidmətlərin qeydiyyatı üçün nəzərdə tutulub. Yeni məhsul yaratmaq üçün <NewButton>Yeni məhsul</NewButton>
                        düyməsinə sıxmaq lazımdır. Açılan pəncərədə məhsulun adı, varsa barkodu, qrupu, alış və satış qiymətini qeyd edib <SaveButton />{" "}
                        düyməsini sıxmaq lazımdır. Məhsulun sifarişi üçün təyin edəcəyiniz sayı <b>minimal qalıq</b> xanasında qeyd edin. Hansı təchizatçıdan
                        alındığını qeyd etmək üçün <Link to={""}>Təchizatçı</Link> xanasını qeyd edin.
                    </p>
                    <img src="/images/products/parameters/product.gif" alt="Məhsul" />
                </article>
            </div>
        </div>
    );
};
